module.exports = __webpack_public_path__ + "img/life-insurance-hands.7de67ea.png";